import { render, staticRenderFns } from "./copyPeople.vue?vue&type=template&id=6d87eeda&scoped=true"
import script from "./copyPeople.vue?vue&type=script&lang=js"
export * from "./copyPeople.vue?vue&type=script&lang=js"
import style0 from "./copyPeople.vue?vue&type=style&index=0&id=6d87eeda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d87eeda",
  null
  
)

export default component.exports